var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSynicateProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.9889 7.6642h-1.9981v-1.3321c0-.73932-.5928-1.3321-1.3321-1.3321h-3.99635c-.73931 0-1.3321.59278-1.3321 1.3321v1.3321h-1.99815c-.73932 0-1.3321.59279-1.3321 1.3321v7.3266c0 .7393.59278 1.3321 1.3321 1.3321h5.995v-1.3321h-5.995v-1.3321-5.9945h1.99815v1.3321h1.3321v-1.3321h3.99635v.00004h1.3321v-.00004h1.9981v.00004h1.3321v-.00004c0-.73931-.5928-1.3321-1.3321-1.3321zm-7.32655-1.3321h3.99635v1.3321h-3.99635zm3.33065 8.1491 1.5051-1.3142c.7272.8328.6419 2.0921-.1909 2.8194zm2.5085-2.1904 1.0034-.8761c1.6954 1.9416 1.4962 4.8831-.4454 6.5785l-.8761-1.0034c1.3847-1.2091 1.5272-3.3143.3181-4.699zm2.0068-1.7523 1.0034-.87615c2.6592 3.04535 2.3505 7.67415-.6999 10.33765l-.8761-1.0034c2.4935-2.1773 2.7499-5.9646.5726-8.4581z",
    fill: "#d337f2",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSynicateProducts);
export default __webpack_public_path__ + "static/media/icon_synicate_products.ce4b85cf.svg";
export { ForwardRef as ReactComponent };